import { render, staticRenderFns } from "./noticeadd.vue?vue&type=template&id=68a02f82"
import script from "./noticeadd.vue?vue&type=script&lang=js"
export * from "./noticeadd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports